const ENABLE_TENANT_EXTRACTION =
  process.env.REACT_APP_ENABLE_TENANT_EXTRACTION === "true";

const getTenantId = () => {
  if (ENABLE_TENANT_EXTRACTION) {
    const extractedTenant = localStorage.getItem("dev_tenant");
    if (extractedTenant) {
      return extractedTenant;
    }
  }

  const hostname = window.location.hostname;


  if (hostname.startsWith("localhost")) return "stage";

  return hostname.split(".")[0];
};

export default getTenantId;
